import Preorder from '../../models/Preorder'
import requestAction from '../../utils/requestAction'

export const fetchPreorder = (preorderId: any, handleResponse?: (preorder: Preorder) => void) =>
  requestAction('PREORDER_DATA')(`preorders/${preorderId}`, 
'GET'
, undefined, undefined, undefined,

(_dispatch, _getState, response) => { if (response === '' || response === null) response = undefined; if(response && handleResponse) handleResponse(response.preorder)}
)


export const fetchPendingPreorder = (handleResponse?: (preorder: Preorder) => void) =>
  requestAction('PREORDER_DATA')(`pendingPreorders`, 'GET'
, undefined, undefined, undefined,

(_dispatch, _getState, response) => { if (response === '' || response === null) response = undefined; if(response && handleResponse) handleResponse(response.preorder)}
)

